module.exports = __webpack_public_path__ + "static/media/opposition-1.1a70a502.png";